import React from 'react'

import { colors } from 'styles/colors'
import { aleloTudoGroups } from './alelo-tudo-groups'
import { aleloPodGroups } from './pod-groups'

import {
    Tudo,
    Despesas,
    GestaoVT,
    Multibeneficios,
    Pagamentos,
    Premiacao,
    Veloe,
    VeloeGO,
    PodTiffany,
    Pod
} from 'assets/img/cards'

import {
    BgVeloe,
    BgVeloeGO,
    BgDespesas,
    BgGestaoVT,
    BgMultibeneficios,
    BgPagamentos,
    BgPremiacao
} from 'assets/img/card-backgrounds'

export const cards = [
    {
        id: 568,
        code: '568',
        type: 'Multibenefits',
        name: 'Multibenefícios',
        image: Multibeneficios,
        bgImage: BgMultibeneficios,
        description:
            'A solução de antecipação salarial que proporciona ao seu colaborador os maiores descontos em medicamentos.',
        link: 'https://www.alelo.com.br/empresas/cartao-alelo-antecipacao-salario-multibeneficios',
        flipped: false,
        vendible: false,
        showTo: []
    },
    {
        id: 608,
        code: '608',
        type: 'Awards',
        name: 'Premiação',
        image: Premiacao,
        bgImage: BgPremiacao,
        description:
            'Um jeito diferente de reconhecer seus colaboradores. Você escolhe o formato entre as modalidades: recarregável, carga única ou para uso restritos em locais de lazer',
        link: 'https://www.alelo.com.br/empresas/cartao-prepago-alelo-premiacao',
        flipped: false,
        vendible: false,
        showTo: ['AL', 'BB']
    },
    {
        id: 301,
        code: '301',
        type: 'Fleet',
        name: 'Gestão de Combustível',
        customName: 'Veloe Go',
        image: VeloeGO,
        bgImage: BgVeloeGO,
        description:
            'Proporciona mais controle dos motoristas e veículos, centraliza pagamentos e garante mais eficiência no processo de gestão.',
        link: 'https://quero.alelofrota.com.br/alelo?utm_source=mkt-veloe&utm_medium=cpc&utm_campaign=veloe49_digital-trafego_parcerias_alelo_menu-superior_todos_frota_alelo-frota',
        flipped: false,
        vendible: false,
        showTo: ['AL', 'BB', 'BR']
    },
    {
        id: 607,
        code: '607',
        type: 'Expenses',
        name: 'Despesas',
        image: Despesas,
        bgImage: BgDespesas,
        description:
            'Ideal para pagamento de fornecedores, colaboradores, terceiros e também despesas gerais da sua empresa.',
        link: 'https://www.alelo.com.br/empresas/cartao-prepago-alelo-despesas-corporativas',
        flipped: false,
        vendible: false,
        showTo: ['AL', 'BB']
    },
    {
        id: 606,
        code: '606',
        type: 'Payments',
        name: 'Pagamentos',
        image: Pagamentos,
        bgImage: BgPagamentos,
        description:
            'Ideal para pagamento de fornecedores, colaboradores, terceiros e também despesas gerais da sua empresa.',
        link: 'https://www.alelo.com.br/empresas/cartao-prepago-alelo-pagamento-salario',
        flipped: false,
        vendible: false,
        showTo: ['AL', 'BB']
    },
    {
        id: 998,
        code: '998',
        type: 'VT',
        name: 'Gestão de VT',
        image: GestaoVT,
        bgImage: BgGestaoVT,
        description:
            'Aquisição e gerenciamento do vale-transporte das empresas com operadoras de todo o Brasil. Um serviço completo que facilita seu dia.',
        link: 'https://www.alelo.com.br/empresas/gestao-alelo-vale-transporte',
        flipped: false,
        vendible: false,
        showTo: ['AL', 'BB', 'BR']
    },
    {
        id: 999,
        code: '999',
        type: 'Veloe',
        name: 'Pagamento de Pedágio',
        customName: 'Veloe',
        image: Veloe,
        bgImage: BgVeloe,
        description:
            'Com Veloe, seu cliente passa sem filas em pedágios e estacionamentos, tem controle de gastos com a frota e reduz o tempo de viagem.',
        link: 'https://veloe.com.br/?utm_source=mkt-veloe&utm_medium=cpc&utm_campaign=veloe49_digital-trafego_parcerias_alelo_menu-superior_todos_pf-todos_veloe',
        flipped: false,
        vendible: false,
        showTo: ['AL', 'BB', 'BR']
    }
]

export const tudoProduct = {
    id: 900,
    code: '900',
    type: 'TUDO',
    name: 'Alelo Tudo',
    image: Tudo,
    bgMobile: colors.deepTeal,
    colorMobile: colors.lime,
    gradientColor: colors.limeAqua,
    color: colors.defaultGreen,
    title: (
        <>
            Alelo <strong>Tudo</strong>
        </>
    ),
    subtitle: 'ALIMENTAÇÃO, REFEIÇÃO E/OU BENEFÍCIOS EM UM ÚNICO CARTÃO',
    desc: 'Todas as soluções que a sua empresa precisa em um único cartão, com a flexibilidade Alelo.',
    text: (
        <>
            O Alelo Tudo é a solução de benefícios flexíveis, completa,{' '}
            <b>modular e adaptável para todas as necessidades</b> e todos os
            tipos e tamanhos de empresas. Com ele, você tem a possibilidade de
            compor o portfólio de benefícios da sua empresa como precisar, seja
            para
            <b>
                {' '}
                alimentação, refeição, auxílios home office, ajuda de custos de
                mobilidade, cultura, saúde e muito mais.
            </b>
        </>
    ),
    link: '/detalhes/alelo-tudo',
    groups: aleloTudoGroups
}

export const podProduct = {
    id: 700,
    code: '700',
    type: 'POD',
    name: 'Alelo POD',
    image: Pod,
    tiffanyImage: PodTiffany,
    bgMobile: colors.bgPurplePod,
    colorMobile: colors.emeraldGreen,
    gradientColor: colors.bgPurplePod,
    color: colors.purplePod,
    title: (
        <>
            Alelo <strong>Pod</strong>
        </>
    ),
    subtitle: 'benefícios flexíveis da Alelo rede Elo',
    desc: 'Mais liberdade para o seu colaborador',
    text: (
        <>
            <b>Mais liberdade para o seu colaborador</b>
            <br />
            <br />
            Com o Alelo Pod dá pra pagar despesas de home office, cursos, usar
            no mercado, restaurante, posto de combustível e muito mais! Tudo
            isso aceito nos milhões de estabelecimentos Elo em todo o Brasil.
            <br />
            <br />
            Oferecer o Alelo Pod como o benefício flexível da sua empresa pode
            te ajudar com a atração e retenção de talentos
        </>
    ),
    link: '/detalhes/alelo-pod',
    groups: aleloPodGroups
}
